import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Layout from "./components/Layout";

import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductCategoryPage from "./pages/ProductCategoryPage";
import ReferencesPage from "./pages/ReferencesPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactPage from "./pages/ContactPage";
import QuoteRequestPage from "./pages/QuoteRequestPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="termekek" element={<ProductsPage />} />
            <Route path="termekek/nyitott-teraszok" element={<ProductCategoryPage category="nyitott-teraszok" />} />
            <Route path="termekek/eltolhato-uvegfalu-teraszok" element={<ProductCategoryPage category="eltolhato-uvegfalu-teraszok" />} />
            <Route path="termekek/szabadonallo-teraszok" element={<ProductCategoryPage category="szabadonallo-teraszok" />} />
            <Route path="termekek/uveg-terasztetok" element={<ProductCategoryPage category="uveg-terasztetok" />} />
            <Route path="termekek/polikarbonat-terasztetok" element={<ProductCategoryPage category="polikarbonat-terasztetok" />} />
            <Route path="termekek/oldalarnyekolo" element={<ProductCategoryPage category="oldalarnyekolo" />} />
            <Route path="termekek/tetoarnyekolo" element={<ProductCategoryPage category="tetoarnyekolo" />} />
            <Route path="termekek/kocsibeallok" element={<ProductCategoryPage category="kocsibeallok" />} />
            <Route path="referenciak" element={<ReferencesPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:slug" element={<BlogPostPage />} />
            <Route path="kapcsolat" element={<ContactPage />} />
            <Route path="arajanlat-keres" element={<QuoteRequestPage />} />
            <Route path="adatkezelesi-tajekoztato" element={<PrivacyPolicyPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
